import { createTheme } from '@mui/material/styles';

export const colors = {
    green: '#16a34a',
    greenDark: '#15803d',
    // Small text (eyebrows, numbers): the brand green fails AA at overline sizes.
    greenText: '#166534',
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: colors.green },
    secondary: { main: '#f50057' },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", sans-serif',
    h3: { fontWeight: 800 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none' },
  },
  shape: {
    borderRadius: 12,
  },
});

export default theme;
